import { ButtonPrimary, ButtonSize } from '@ui/src';
import { CustomerStatus } from '../../../../hoc/common/types';
import RealMonthlyVolume from './real-monthly-volume';
import { RealMonthlyVolumesTypes } from '../types';

import cn from '../styles.module.css';

const RealMonthlyVolumes = ({
  children,
  title,
  monthlyMaxValueIncomingPaymentRangeId,
  monthlyMaxValueOutgoingPaymentRangeId,
  monthlyNumberIncomingTransactionsRangeId,
  monthlyNumberOutgoingTransactionsRangeId,
  monthlyTurnoverRangeId,
  monthlyValueIncomingTransactionsRangeId,
  monthlyValueOutgoingTransactionsRangeId,
  corporate,
  onChange,
  status,
  saveButtonDisabled,
  requestInProgress,
  onSaveChanges,
  montlyTurnoverValues,
}: RealMonthlyVolumesTypes): React.JSX.Element => (
  <div
    className={`${cn.realMonthlyVolumeWrapper} ${
      corporate ? cn.realMonthlyVolumeWrapperCorporate : ''
    }`}
  >
    <div
      className={`${cn.expandableRowTop} ${cn.withoutBackground} ${cn.expandableRowTopWithButton}`}
    >
      <div
        className={`${cn.expandableRowTitle} ${cn.expandableRowTitleWithButton} ${cn.noPadding}`}
      >
        <div className={cn.expandableRowTitleValue}>{title}</div>
        <ButtonPrimary
          text={requestInProgress ? 'Loading...' : 'Save changes'}
          size={ButtonSize.SMALL}
          disabled={saveButtonDisabled}
          onClick={onSaveChanges}
        />
      </div>
    </div>
    <div className={cn.realMonthlyVolumeWrapper}>
      <RealMonthlyVolume
        title="N. of incoming transactions"
        value={monthlyNumberIncomingTransactionsRangeId}
        list={
          corporate
            ? montlyTurnoverValues?.numberOfIncomingTransactionsCorporate
            : montlyTurnoverValues?.numberOfIncomingTransactions
        }
        onUpdateRange={(data) =>
          onChange({
            target: {
              name: 'monthlyNumberIncomingTransactionsRangeId',
              value: data,
            },
          })
        }
        disabled={status === CustomerStatus.CLOSED}
      />
      <RealMonthlyVolume
        title="N. of outgoing transactions"
        value={monthlyNumberOutgoingTransactionsRangeId}
        list={
          corporate
            ? montlyTurnoverValues?.numberOfOutgoingTransactionsCorporate
            : montlyTurnoverValues?.numberOfOutgoingTransactions
        }
        onUpdateRange={(data) =>
          onChange({
            target: {
              name: 'monthlyNumberOutgoingTransactionsRangeId',
              value: data,
            },
          })
        }
        disabled={status === CustomerStatus.CLOSED}
      />
      <RealMonthlyVolume
        title="Value of incoming transactions"
        value={monthlyValueIncomingTransactionsRangeId}
        list={
          corporate
            ? montlyTurnoverValues?.valueOfIncomingTransactionsCorporate
            : montlyTurnoverValues?.valueOfIncomingTransactions
        }
        onUpdateRange={(data) =>
          onChange({
            target: {
              name: 'monthlyValueIncomingTransactionsRangeId',
              value: data,
            },
          })
        }
        disabled={status === CustomerStatus.CLOSED}
      />
      <RealMonthlyVolume
        title="Value of outgoing transactions"
        value={monthlyValueOutgoingTransactionsRangeId}
        list={
          corporate
            ? montlyTurnoverValues?.valueOfOutgoingTransactionsCorporate
            : montlyTurnoverValues?.valueOfOutgoingTransactions
        }
        onUpdateRange={(data) =>
          onChange({
            target: {
              name: 'monthlyValueOutgoingTransactionsRangeId',
              value: data,
            },
          })
        }
        disabled={status === CustomerStatus.CLOSED}
      />
      <RealMonthlyVolume
        title="Max. value of incoming payment"
        value={monthlyMaxValueIncomingPaymentRangeId}
        list={
          corporate
            ? montlyTurnoverValues?.maxValueOfIncomingPaymentCorporate
            : montlyTurnoverValues?.maxValueOfIncomingPayment
        }
        onUpdateRange={(data) =>
          onChange({
            target: {
              name: 'monthlyMaxValueIncomingPaymentRangeId',
              value: data,
            },
          })
        }
        disabled={status === CustomerStatus.CLOSED}
      />
      <RealMonthlyVolume
        title="Max. value of outgoing payment"
        value={monthlyMaxValueOutgoingPaymentRangeId}
        list={
          corporate
            ? montlyTurnoverValues?.maxValueOfOutgoingPaymentCorporate
            : montlyTurnoverValues?.maxValueOfOutgoingPayment
        }
        onUpdateRange={(data) =>
          onChange({
            target: {
              name: 'monthlyMaxValueOutgoingPaymentRangeId',
              value: data,
            },
          })
        }
        disabled={status === CustomerStatus.CLOSED}
      />
      <RealMonthlyVolume
        title="Monthly turnover"
        value={monthlyTurnoverRangeId}
        list={
          corporate
            ? montlyTurnoverValues?.monthlyTurnoverCorporate
            : montlyTurnoverValues?.monthlyTurnover
        }
        onUpdateRange={(data) =>
          onChange({
            target: { name: 'monthlyTurnoverRangeId', value: data },
          })
        }
        disabled={status === CustomerStatus.CLOSED}
      />
      {children}
    </div>
  </div>
);

export default RealMonthlyVolumes;
